@let vm = cartVoucherVm$ | async;
@if (vm; as cartVoucherVm) {
  @if (cartVoucherVm.isVisible) {
    <div>
      <div class="mx-auto mb-3 max-w-md px-5 lg:max-w-full lg:px-0">
        <app-discount-voucher-atom
          [headingColor]="headingColor"
          (click)="openInputVoucher()"
          (removeVoucher)="onRemoveVoucher($event)"
        ></app-discount-voucher-atom>
      </div>
    </div>
  }
}
